import { render, staticRenderFns } from "./H7ComparisonHero.vue?vue&type=template&id=264ddb6e&scoped=true"
import script from "./H7ComparisonHero.vue?vue&type=script&lang=js"
export * from "./H7ComparisonHero.vue?vue&type=script&lang=js"
import style0 from "./H7ComparisonHero.vue?vue&type=style&index=0&id=264ddb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ddb6e",
  null
  
)

export default component.exports